import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
    selector: 'app-pb-tutor-support-form',
    templateUrl: './pb-tutor-support-form.component.html',
    styleUrls: ['./pb-tutor-support-form.component.scss']
})
export class PbTutorSupportFormComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    paddingTop: any = '';
    paddingBottom: any = '';
    items: any = [];
    courses: any = [];
    tutorSupportForm;

    firstName: any = '';
    lastName: any = '';
    emailAddress: any = '';
    phoneNumber: any = '';
    selectedCourse: any = '';
    subject: any = '';
    studyMaterial: any = '';
    pageNumber: any = '';
    query: any = '';
    institute: any = '';
    subscribe: any = '';
    subjects: any = [];

    processing = false;
    success = false;

    constructor(private cd: ChangeDetectorRef, private api: ApiService, private formBuilder: FormBuilder, private router: Router) {

        this.tutorSupportForm = this.formBuilder.group({
            firstName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$')
            ])),
            lastName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$')
            ])),
            emailAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
            ])),
            phoneNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[0-9]*$'),
            ])),
            institute: new FormControl('', Validators.compose([
                Validators.required
            ])),
            subject: new FormControl('', Validators.compose([
                Validators.required
            ])),
            studyMaterial: new FormControl('', Validators.compose([
                Validators.required
            ])),
            pageNumber: new FormControl('', Validators.compose([
                Validators.required
            ])),
            query: new FormControl('', Validators.compose([
                Validators.required
            ])),
            subscribe: new FormControl(''),
        });

    }

    ngOnInit(): void {

        this.fetchCourses();

        this.content.forEach(element => {
            const item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            };

            this.items.push(item);
        });

        this.paddingTop = this.module.paddingTop; // Module Padding
        this.paddingBottom = this.module.paddingBottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment === 'LEFT') {
            return 'text-left';
        } else if (alignment === 'CENTER') {
            return 'text-center';
        } else if (alignment === 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetch all courses.
     * This data is used in the course dropdown on the contact form
     */
    async fetchCourses() {

        await this.api.fetch_course_list()
            .subscribe(res => {
                res.Result.Course.forEach(element => {
                    let found = false;

                    if (element.hasOwnProperty('SubjectLevels')) {
                        if (element.SubjectLevels.hasOwnProperty('SubjectLevel')) {
                            element.SubjectLevels.SubjectLevel = this.ensureArray(
                                element.SubjectLevels?.SubjectLevel
                            );
                            if (Array.isArray(element.SubjectLevels.SubjectLevel)) {
                                found = true;
                            } else {
                                if (element.SubjectLevels.SubjectLevel.hasOwnProperty('Products')) {
                                    found = true;
                                }
                            }
                        }
                    }

                    if (found) {
                        this.courses.push(element);
                    }
                });

            }, (err) => {

            });

    }

    saveChanges() {

        if (!this.tutorSupportForm.valid) {
            Object.keys(this.tutorSupportForm.controls).forEach(field => {
                const control = this.tutorSupportForm.get(field);
                control.markAsTouched({ onlySelf: true });
            });

            return false;
        }

        let user: any = localStorage.getItem('user');
        let userAccountKey: any = '';

        if (user) {
            try {
                user = JSON.parse(user);
                userAccountKey = user.Result.UserAccountKey._text;
            } catch (err) { }
        }

        const gaUserId = document.cookie.match(/_ga=(.+?)(?:;|$)/)?.[1].split('.').slice(-2).join('.');
        const frm = this.tutorSupportForm.getRawValue();
        const data = {
            firstName: frm.firstName,
            lastName: frm.lastName,
            emailAddress: frm.emailAddress,
            phoneNumber: frm.phoneNumber,
            institute: frm.institute.CourseName._text,
            subject: frm.subject.title,
            studyMaterial: frm.studyMaterial,
            pageNumber: frm.pageNumber,
            myQuery: frm.query,
            subscribe: frm.subscribe,

            // UTM Variables

            formName: 'Tutor Support',
            utmSource: sessionStorage.getItem('utmSource'),
            utmMedium: sessionStorage.getItem('utmMedium'),
            utmCampaign: sessionStorage.getItem('utmCampaign'),
            utmContent: sessionStorage.getItem('utmContent'),
            utmTerm: sessionStorage.getItem('utmTerm'),
            clientId: gaUserId,
            userId: userAccountKey
        };

        this.submitToApi(data);

    }

    async submitToApi(data) {

        this.processing = true;
        this.success = false;

        const redirectUrl = this.module.prebuilt_module_data.redirect_url ? this.module.prebuilt_module_data.redirect_url : false;

        await this.api.submit_tutor_support_form_data(data)
            .subscribe(res => {
                this.processing = false;
                this.cd.detectChanges();

                this.tutorSupportForm.reset();
                this.success = true;

                if (redirectUrl) {
                    this.router.navigateByUrl(redirectUrl);
                }
            }, (err) => {
                this.processing = false;
                this.cd.detectChanges();

                Swal.fire({
                    title: 'Error',
                    text: 'Unable to send your message',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showCloseButton: true,
                    customClass: 'swal-ibtc',
                    position: 'top'
                }).then((result) => {
                });
            });
    }

    /**
     * Easier access to the controlname reference
     */
    get f() {

        return this.tutorSupportForm.controls;

    }

    async instituteChanged(evt) {

        await this.api.fetch_subjects(evt.value.CourseKey._text)
            .subscribe(res => {
                this.subjects = this.ensureArray(res.data.items);
            }, (err) => {

            });

    }

    ensureArray(possibleArray) {
        if (possibleArray) {
            if (Array.isArray(possibleArray)) {
                return possibleArray;
            } else {
                return [possibleArray];
            }
        } else {
            return [];
        }
    }

}
